import styles from "./AsideElementFill.module.scss";

function AsideElementFill() {
  return <div className={styles["fill"]} />;
}

export default AsideElementFill;
